// extracted by mini-css-extract-plugin
export default {"imageDetails":"imageDetails_imageDetails__y1FCd","user":"imageDetails_user__67qKJ","likeContainer":"imageDetails_likeContainer__++xPM","unliked":"imageDetails_unliked__qIUa5"};